module.exports = __webpack_public_path__ + "img/description-1.45392232.svg";